import React, { PureComponent } from "react";
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class TableHeader extends PureComponent {
    constructor(props) { super(props); }

    render() {
        const { limitesCliente } = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <span className="fa fa-money fa-lg"></span>
                        <label className="label-secondary  left-separator-xxs">Límite global total:</label>
                    </div>
                    <div className="col-md-5">
                        <label className="label-secondary">$ {GlobalHelper.ConvertirNumeroSinDecimales(limitesCliente.LimitePorCuit)}</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <strong>
                            <label className="label-secondary">Límite asignado:</label>
                        </strong>
                    </div>
                    <div className="col-md-5">
                        <strong>
                            <label className="label-secondary">$ {GlobalHelper.ConvertirNumeroSinDecimales(limitesCliente.LimiteAsignado)}</label>
                        </strong>
                    </div>
                </div>
            </div>
        );
    }
}

export default TableHeader;